export default "__VITE_ASSET__Bbd2UBVU__"